import * as c from '../constants';

export const myUsers = (state = c.INIT_STATE, action) => {
	switch(action.type) {
        case c.MYUSERS_LOADING:
            return Object.assign({}, state, {
                isLoading: action.isLoading
            })
        case c.MYUSERS_GET:
            return Object.assign({}, state, {
                users: action.data
            })
        default:
            return state;
    }
}






// WEBPACK FOOTER //
// ./src/my-users/reducers/index.js